import { useRef, useState } from 'react'

import styles from './styles/PublicationHistory.css'
import OpenerIcon from './OpenerIcon'
import Fade from './Fade'
import useClickOut from '../../hooks/useClickOut'

const PublicationHistory = ({ paper }) => {
  const [show, setShow] = useState(false)
  const ref = useRef(null)

  useClickOut(ref, show, () => setShow(false))

  if (!paper || (paper.preprintLinks?.length === 0 && paper.publicationLinks?.length === 0)) {
    return null
  }
  return (
    <div ref={ref} className={styles.layout}>
      <span className={styles.header} onClick={() => setShow(!show)} role='button' tabIndex={0}><div>{paper.preprintLinks?.length > 0 ? 'View preprint versions' : 'View published versions'}{' '}</div><OpenerIcon className={styles.icon} show={show} /></span>
      {show &&
        <ul className={styles.dropdown}>
          <Fade show={show}>
            {paper.preprintLinks?.length > 0 && paper.preprintLinks.map((preprint, i) => (
              <li key={i} className={styles.notice}>
                <a target='_blank' rel='noopener noreferrer' href={`${CONFIG.sciteFrontendURL}/reports/${preprint.preprintDoi}`} className={styles.status}>
                  Preprint #{i + 1}: {preprint.preprintDoi}
                </a>
              </li>
            ))}
            {paper.publicationLinks?.length > 0 && paper.publicationLinks.map((publication, i) => (
              <li key={i} className={styles.notice}>
                <a target='_blank' rel='noopener noreferrer' href={`${CONFIG.sciteFrontendURL}/reports/${publication.publishedDoi}`} className={styles.status}>
                  Publication #{i + 1}: {publication.publishedDoi}
                </a>
              </li>
            ))}
          </Fade>
        </ul>}
    </div>
  )
}

export default PublicationHistory
